const doc = [({"en":({"adminConstantBankDepositType":({"checkingAccount":"Checking Account", "ordinaryDeposit":"Ordinary Deposit"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;